export const PIECHART_SLICE_COLORS: ReadonlyArray<string> = [
  '#66FEC1', // mint accent
  '#5B9EFF', // blue
  '#F29F57', // amber
  '#A78BFA', // lavender
  '#FF7EB3', // pink
  '#45E0C4', // teal
  '#FDCB6E', // gold
  '#7B8CDE', // periwinkle
  '#FF8A65', // salmon
  '#81C784', // sage
];

export const DONUT_SIZE = 160;
export const DONUT_TRACK_WIDTH = 9;
export const DONUT_GAP_DEGREES = 5;
export const LEGEND_DOT_SIZE = 10;
export const PIECHART_METRIC_UNIT = 'TOTAL';
export const PIECHART_CENTER_TEXT_ALIGN = 'center';

export const PIECHART_GLOW_PAD = 10;
export const PIECHART_FULL_CIRCLE_DEGREES = 360;
export const PIECHART_HALF_TURN_DEGREES = 180;
export const PIECHART_ANGLE_OFFSET_DEGREES = 90;
export const PIECHART_COMPACT_CENTER = 50;
export const PIECHART_COMPACT_INNER_CIRCLE_RADIUS = 23;
export const PIECHART_COMPACT_OUTER_RADIUS = 38;
export const PIECHART_COMPACT_INNER_RADIUS = 24;
export const PIECHART_COMPACT_GAP_DEGREES = 3;
